import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-12 grid grid-cols-1 sm:grid-cols-3 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="text-2xl">🐾</span>
            <span className="font-bold text-lg tracking-tight">PetHouse</span>
          </div>
          <p className="text-slate-400 text-sm leading-relaxed">
            Connecting loving families with healthy, happy pets — one companion
            at a time.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-300 mb-4">
            Quick Links
          </h4>
          <ul className="space-y-2">
            {[
              { label: "Home", to: "/" },
              { label: "Explore Pets", to: "/explore" },
              { label: "Login", to: "/login" },
              { label: "Register", to: "/register" },
            ].map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="text-slate-400 text-sm hover:text-amber-400 transition-colors"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-300 mb-4">
            Follow Us
          </h4>
          <div className="flex gap-4">
            {[
              { href: "https://facebook.com", icon: <FaFacebook size={18} /> },
              { href: "https://twitter.com", icon: <FaTwitter size={18} /> },
              {
                href: "https://instagram.com",
                icon: <FaInstagram size={18} />,
              },
            ].map(({ href, icon }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-amber-400 transition-colors"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800 py-4 px-6 text-center text-xs text-slate-500">
        © 2024 PetHouse. All Rights Reserved. Designed by Jakia A.
      </div>
    </footer>
  );
};

export default Footer;
